// tienda/StatsStrip.jsx
// Four KPI pills: price, cutoff time, OTD rate, COD.

import React from "react";
import { motion } from "framer-motion";
import { brand, fadeUp } from "../shared/brand";

const STATS = [
  { value: "S/ 8.90", label: "Desde por entrega",    color: brand.primary },
  { value: "4 PM",    label: "Último corte same-day", color: brand.accentGreen },
  { value: "95%",     label: "Entregas a tiempo",     color: brand.accentGold },
  { value: "COD",     label: "Cobro contraentrega",   color: brand.primary },
];

export function StatsStrip() {
  return (
    <section className="bg-white border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-4 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {STATS.map(s => (
            <motion.div
              key={s.label}
              {...fadeUp}
              className="rounded-2xl border border-slate-100 bg-slate-50 p-4 text-center"
            >
              <div className="text-2xl font-extrabold" style={{ color: s.color }}>{s.value}</div>
              <div className="text-xs text-slate-500 mt-0.5">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}